export enum Groups {
  ADMIN = 'admin',
  HOST = 'host',
}
